// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ name: string; value: string }>;

export const DispatchUpdateWarehousesPickTypes: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/CheckoutReviewAndSubmit/UpdateWarehousesPickTypes",
        warehousesPickType: { name: props.parameter.name, value: props.parameter.value },
    });
};

export const chain = [DispatchUpdateWarehousesPickTypes];

const updateWarehousesPickTypes = createHandlerChainRunner(chain, "UpdateWarehousesPickTypes");
export default updateWarehousesPickTypes;
